import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Button, Box } from '@material-ui/core';
import { withTranslation } from 'config/i18n';
import AddIcon from '@material-ui/icons/Add';

const useStyles = makeStyles((theme) => ({
  noVehicleInfo: {
    margin: theme.spacing(2.5, 0, 3),
  },
}));

const NoVehicle = (props) => {
  const classes = useStyles();
  const {
    t, state, addingVehicle,
  } = props;
  return (
    <>
      <Box mb={4}>
        <Typography
          variant="h4"
          className={classes.noVehicleInfo}
          dangerouslySetInnerHTML={{
            __html: t(
              'fe_es_bikes_list:not_have_active_bikes',
              {
                state,
              },
            ),
          }}
        />
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          disableElevation
          onClick={addingVehicle}
        >
          {`${t('fe_es_bikes_list:list_new_bike')} ${t('fe_es_bikes_list:now')}`}
        </Button>
      </Box>
    </>
  );
};
export default withTranslation('fe_es_bikes_list')(NoVehicle);
